import {BaseModel} from "../../../infrastructure/models/base-model";
import {BaseLinkModelSettings} from "../../../infrastructure/models/link/base-link-model-settings";
import {BaseUrlModel} from "../../../infrastructure/models/link/base-url-model";
import {makeObservable, observable} from "mobx";

export class PromotionBannerModel extends BaseModel {
  url: String;
  desktopImageUrl: String;
  mobileImageUrl: String;
  @observable isVisible: Boolean;
  validUserCountryIds: Array<Number>;
  validLanguageIds: Array<Number>;
  constructor(model) {
    super();

    this.url = model?.url;
    this.isVisible = model?.isVisible;
    this.validUserCountryIds = model?.validUserCountryIds;
    this.validLanguageIds = model?.validLanguageIds;
    this.relatedEntities = model?.relatedEntities;

    this.desktopImageUrl = model?.desktopImageUrl;
    this.mobileImageUrl = model?.mobileImageUrl;

    makeObservable(this);
  }

  get linkModel() {
    const setting = new BaseLinkModelSettings();
    setting.shouldOpenNewTab = true;

    return new BaseUrlModel( this.url, true, setting);
  }

  IsValid(userCountryId: Number, languageId: Number, competitionId: Number, competitorId: Number) {
    let isValid = false;

    if(this.isVisible) {
      const isValidForUser = this.isValidByUserCountryId(userCountryId) && this.isValidByLanguageId(languageId);
      const isRelatedToEntity = this.isRelatedToEntity(competitionId, competitorId);

      isValid = isValidForUser && isRelatedToEntity;
    }

    return isValid;
  }

  isValidByUserCountryId(userCountryId: Number) {
    return this.validUserCountryIds?.includes(-1) || this.validUserCountryIds?.includes(userCountryId);
  }

  isValidByLanguageId(languageId: Number) {
    return this.validLanguageIds?.includes(-1) || this.validLanguageIds?.includes(languageId);
  }

  isRelatedToEntity(competitionId: Number, competitorId: Number) {
    let isRelated = false;

    isRelated |= this.relatedEntities?.competitionIds?.includes(-1) || this.relatedEntities?.competitionIds?.includes(competitionId);
    isRelated |= this.relatedEntities?.competitiorIds?.includes(-1) || this.relatedEntities?.competitiorIds?.includes(competitorId);

    return isRelated;
  }
}
